import styled from 'styled-components';
import { layout } from 'src/components/base';
import { Link } from 'react-router-dom';
import { BodySmallText, H2Text } from '@prisjakt/ui/text/variants';

export const DescriptionContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.lines.secondary};
  margin: ${layout.measurements.spacing050};
  margin-top: ${layout.measurements.spacing150};
  margin-bottom: ${layout.measurements.spacing150};
  padding: ${layout.measurements.spacing150} 0 0 0;
`;

export const DescriptionTitle = styled(H2Text)`
  margin: 0 0 ${layout.measurements.spacing050} 0;
`;

export const Description = styled(BodySmallText)`
  display: inline-block;
  margin: 0;
  max-width: 600px;
`;

export const AliasLink = styled(Link)`
  color: ${p => p.theme.text.linkExternal};
  &:hover {
    color: ${p => p.theme.text.linkExternalHover};
  }
`;
